/**
 * This is the domain used for local development. Available when running with `yarn start-all`.
 */
export const PROTON_LOCAL_DOMAIN = 'proton.dev';
